// PawLink install helpers — shared by <InstallSection /> and /install page.
// Kept dependency-free so it can be imported anywhere (React tree or plain
// utility scripts). Every function is side-effect-free and idempotent.

/**
 * Detect the current device family based on User-Agent.
 * Returns: 'ios' | 'android' | 'desktop'.
 */
export function detectDevice() {
    const ua = typeof navigator !== "undefined" ? navigator.userAgent || "" : "";
    if (/iPad|iPhone|iPod/.test(ua) && !window.MSStream) return "ios";
    if (/Android/i.test(ua)) return "android";
    return "desktop";
}

/**
 * Detect the current browser (best-effort, sufficient for showing the
 * right "how to install" instructions).
 * Returns: 'chrome' | 'edge' | 'brave' | 'opera' | 'safari' | 'firefox' | 'samsung' | 'other'.
 */
export function detectBrowser() {
    const ua = typeof navigator !== "undefined" ? navigator.userAgent : "";
    if (/EdgA?\//.test(ua)) return "edge";
    if (/OPR\/|Opera/i.test(ua)) return "opera";
    if (/Brave/i.test(ua)) return "brave";
    if (/SamsungBrowser/i.test(ua)) return "samsung";
    if (/CriOS|Chrome/.test(ua) && !/EdgA?\/|OPR\/|SamsungBrowser/.test(ua)) return "chrome";
    if (/Safari/.test(ua) && !/Chrome|CriOS|Chromium/.test(ua)) return "safari";
    if (/Firefox|FxiOS/i.test(ua)) return "firefox";
    return "other";
}

/**
 * True when the current page is already running as an installed PWA / TWA.
 */
export function isStandalone() {
    if (typeof window === "undefined") return false;
    try {
        return (
            window.matchMedia("(display-mode: standalone)").matches ||
            window.navigator.standalone === true
        );
    } catch {
        return false;
    }
}

/**
 * Attach a listener that captures the browser's `beforeinstallprompt` event
 * and calls back with the deferred prompt so the caller can trigger it later.
 * Returns an unsubscribe function.
 */
export function captureInstallPrompt(onCaptured) {
    if (typeof window === "undefined") return () => {};
    const onPrompt = (e) => { e.preventDefault(); onCaptured?.(e); };
    window.addEventListener("beforeinstallprompt", onPrompt);
    return () => window.removeEventListener("beforeinstallprompt", onPrompt);
}
